import {lazy} from '@aboutyou/lazy-imports';

export const AppInstallTeaser = lazy(() =>
  import('./AppInstallTeaser.eager').then(mod => ({
    default: mod.AppInstallTeaser,
  })),
);
